module.exports = __webpack_public_path__ + "media/promotional/bachelor-party-79490913.jpg";